<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BOfX70/tc-custom/9781035877287.jpg?1737197407696" alt="This image is the cover for the book Unexpected Endings"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Unexpected Endings
      </h1>
      <p class="bookDescription body article font2">
        <p>There are said to be two types of writers: those who meticulously plot their stories before ever setting pen to paper, and those who dive headfirst into a blank page, trusting that meaning will emerge through the process. I firmly belong to the latter group. When I began writing proper short stories – rather than scribbles on the backs of bus tickets – I never imagined they would one day form a collection. But as the stories accumulated, I realized there might be enough to satisfy the growing number of readers who had enjoyed them and were eager for more. My imagination is a restless and untamed force, often pulling me in unexpected directions, making each story a new adventure in creativity. I delight in experimenting with words, stretching and reshaping them into fresh contexts. Unexpected Endings is driven by this love of storytelling, blending my interests in science and folklore – two endless sources of inspiration. In this collection, you’ll find stories like Azrael, where a goldfinch holds far more meaning than meets the eye, and Light and Dark, where nothing is quite what it seems.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sue Frazer
      </h2>
      
      <p class="authorDescription body article">Sue Frazer started experimenting with writing short stories in her childhood, finding opportunities in the hurly-burly of life to set down her thoughts and observations. She joined a creative writing group several years ago and since retirement has experienced some tough challenges which she feels have given her a new, more insightful view of the world. Sue’s writing encompasses a broad spectrum of fiction, from dark to light, horror to humour. And sometimes a mixture of more than one component.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3c9bc292